module.exports = __webpack_public_path__ + "static/media/eve-bnb.dba02628.svg";